import React from 'react';
import { LQ_VIEWS } from '../../constants/common';
import Loader from '../common/loader/Loader';

const AddressQualification = React.lazy(() => import('../address-qualification'));
const ServiceUnavailable = React.lazy(() => import('../service-unavailable'));
const OrderFiveGHome = React.lazy(() => import('../order-fiveg-home'));
const OrderFios = React.lazy(() => import('../order-fios'));
const OrderLteHome = React.lazy(() => import('../order-lte-home'));
const ResumeSmartCart = React.lazy(() => import('../resume-smart-cart'));
const BusinessAddress = React.lazy(() => import('../business-address'));
const Commonlq = React.lazy(() => import('../common-lq'));
const MoveLq = React.lazy(() => import('../move-lq'));
const BulkLq = React.lazy(() => import('../bulk-lq'));
const Lbo = React.lazy(() => import('../lbo'));
const Loading = React.lazy(() => import('../common/loader/loading.js'));
const VFDiscountView = React.lazy(() => import('../verizonForward/VFDiscountView'));
const VFEmployeeNotEligible = React.lazy(() => import('../verizonForward/VFEmployeeNotEligible'));
const VFNYDiscountView = React.lazy(() => import('../verizonForward/VFNYDiscountView'));
const VFQuestionaireView = React.lazy(() => import('../verizonForward/VFQuestionaireView'));
const VFMnHQualifiedView = React.lazy(() => import('../verizonForward/VFMnHQualifiedView'));
const InitalLoader = React.lazy(() => import('../initial-loader'));
const SessionTimeOutView = React.lazy(() => import('../common/SessionTimeout'));
const HomeLQMainView = React.lazy(() => import('../home-lq'));
const ResumeSendCart = React.lazy(() => import('../order-fios/resumeSendCart.js'));
const InService = React.lazy(() => import('../order-fios/inService.js'));
const HereMapView = React.lazy(() => import('../home-lq/HereMapHomeLq.js'));
const ComboEmailSignInView = React.lazy(() => import('../combo-email-signin'));
const SequentialFwaLoginModal = React.lazy(() => import('../email-adaptive-authentication/sequentialFwaLoginModal.js'));
const MnhYesNoView = React.lazy(() => import('../mnh-yes-no'));
const TgwPendingOrderView = React.lazy(() => import('../common/pendingOrder.js'));
const EmailAuthenticationView = React.lazy(() => import('../email-adaptive-authentication/EmailAuthenticationView.js'));
const EmailConfirmationView = React.lazy(() => import('../email-adaptive-authentication/EmailConfirmationView.js'));
const EmailTimeoutView = React.lazy(() => import('../email-adaptive-authentication/EmailTimeout.js'));

export const getCurrentBaseView = (currentLQView, props, homeLQ) => {
  let returnComp;
  switch (currentLQView) {
    case LQ_VIEWS.HOME_LQ_VIEW:
      returnComp = <HomeLQMainView {...props} />;
      break;
    case LQ_VIEWS.LBO_VIEW:
      returnComp = <Lbo />;
      break;
    case LQ_VIEWS.UN_QUALIFIED_VIEW:
      returnComp = <ServiceUnavailable />;
      break;
    case LQ_VIEWS.FIVEG_HOME_QUALIFIED_VIEW:
      returnComp = <OrderFiveGHome />;
      break;
    case LQ_VIEWS.FIOS_QUALIFIED_VIEW:
      returnComp = <OrderFios />;
      break;
    case LQ_VIEWS.LTE_HOME_QUALIFIED_VIEW:
      returnComp = <OrderLteHome />;
      break;
    case LQ_VIEWS.RESUME_SMART_CART_VIEW:
      returnComp = <ResumeSmartCart />;
      break;
    case LQ_VIEWS.BUSINESSADDRESS_VIEW:
      returnComp = <BusinessAddress />;
      break;
    case LQ_VIEWS.COMMON_LQ:
      returnComp = <Commonlq />;
      break;
    case LQ_VIEWS.VF_QUAL_FWA:
      returnComp = <VFDiscountView />;
      break;
    case LQ_VIEWS.VF_QUESTIONAIRE:
      returnComp = <VFQuestionaireView />;
      break;
    case LQ_VIEWS.VF_MNH_QUALIFIED_VIEW:
      returnComp = <VFMnHQualifiedView />;
      break;
    case LQ_VIEWS.MULTIPLE_SERVICES_QUALIFIED_MV_VIEW:
      returnComp = <MoveLq />;
      break;
    case LQ_VIEWS.VFNY_DISCOUNT:
      returnComp = <VFNYDiscountView />;
      break;
    case LQ_VIEWS.VF_Employee_NotEligible:
      returnComp = <VFEmployeeNotEligible />;
      break;
    case LQ_VIEWS.BULK_SERVICES_QUALIFIED_VIEW:
      returnComp = <BulkLq />;
      break;
    case LQ_VIEWS.FIOS_LOADING_VIEW:
      returnComp = <Loading />;
      break;
    case LQ_VIEWS.BLANK_LOADER_VIEW:
      returnComp = <InitalLoader />;
      break;
    case LQ_VIEWS.SESSION_TIMEOUT_VIEW:
      returnComp = <SessionTimeOutView />;
      break;
    case LQ_VIEWS.HOME_HELP_VIEW:
      returnComp = <AddressQualification />;
      break;
    case LQ_VIEWS.RESUME_SEND_CART_VIEW:
      returnComp = <ResumeSendCart {...props} />;
      break;
    case LQ_VIEWS.IN_SERVICE_VIEW:
      returnComp = <InService {...props} />;
      break;
    case LQ_VIEWS.HERE_MAP_VIEW:
      returnComp = <HereMapView {...props} />;
      break;
    case LQ_VIEWS.COMBO_EMAIL_SIGNIN_VIEW:
      returnComp = <ComboEmailSignInView />;
      break;
    case LQ_VIEWS.EMAIL_AUTHENTICATION:
      returnComp = <EmailAuthenticationView />;
      break;
    case LQ_VIEWS.EMAIL_CONFIRMATION:
      returnComp = <EmailConfirmationView />;
      break;
    case LQ_VIEWS.EMAIL_TIMEOUT:
      returnComp = <EmailTimeoutView />;
      break;
    case LQ_VIEWS.SEQUENTIAL_FWA_LOGIN:
      returnComp = <SequentialFwaLoginModal />;
      break;
    case LQ_VIEWS.MNH_YES_OR_NO_VIEW:
      returnComp = <MnhYesNoView />;
      break;
    case LQ_VIEWS.TGW_PENDING_ORDER_VIEW:
      returnComp = <TgwPendingOrderView {...props} />;
      break;
    default:
      returnComp = <AddressQualification />;
  }
  return <React.Suspense fallback={<Loader active />}>{homeLQ ? returnComp : <div>{returnComp}</div>}</React.Suspense>;
};
